import { gql } from 'graphql-request';
import {
  ProductID,
  ProductUUID,
  ProductImageID,
  ProductImageName,
  ProductImageFile,
  ProductImageSize,
  ProductImageUUID,
  ProductNanoID
} from '../productsTypes';

export interface FetchShowProductImageQueryResponseImage {
  id: ProductImageID;
  uuid: ProductImageUUID;
  file: ProductImageFile;
  size: ProductImageSize;
  name: ProductImageName;
}

export interface FetchShowProductImageQueryResponse {
  id: ProductID;
  nanoId: ProductNanoID;
  uuid: ProductUUID;
  image: FetchShowProductImageQueryResponseImage;
}

export const FETCH_SHOW_PRODUCT_IMAGE_QUERY = gql`
  query ShowProductImage($uuid: ID!) {
    product(uuid: $uuid) {
      id
      nanoId
      uuid
      image {
        id
        uuid
        size
        name
        file
      }
    }
  }
`;
